import { FormControl, ValidatorFn } from "@angular/forms";

export const trimFirstWhiteSpaces = (control: FormControl) => {
    if(!control.value && control.value?.length==0)
        return null;

    if((control.value || '').trim()?.length==0 && control.value?.length>0){
        control.patchValue(control.value.trim(), {onlySelf:true, emitEvent:false });
    }

  return null;
}

export const noWhiteSpaceValidator = (control: FormControl) => {
    return (control.value || '').trim().length? null : { 'whitespace': true };
}
